var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXlsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59cd90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11b55f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Custom_Size_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom_Size_1",
    "data-name": "Custom Size \\u2013 1",
    clipPath: "url(#clip-Custom_Size_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M0,98.275,98.275,0H368.533A24.569,24.569,0,0,1,393.1,24.569V368.533A24.569,24.569,0,0,1,368.533,393.1H24.569A24.569,24.569,0,0,1,0,368.533Z",
    fill: "url(#linear-gradient5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M98.275,0V73.707A24.569,24.569,0,0,1,73.707,98.275H0Z",
    fill: "url(#linear-gradient5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M-79.925-43.068l-25.933-40.71h19.435a6.047,6.047,0,0,1,2.789.489,4.346,4.346,0,0,1,1.581,1.639l16.675,28.233a12.238,12.238,0,0,1,.661-1.438q.374-.69.834-1.437l14.605-25.07a4.383,4.383,0,0,1,3.91-2.415h18.63L-53.015-43.93-26.163,0H-45.6a4.857,4.857,0,0,1-3.076-.92,7.013,7.013,0,0,1-1.869-2.185L-67.333-32.43a11.613,11.613,0,0,1-1.035,2.185l-15.64,27.14a7.82,7.82,0,0,1-1.84,2.156A4.367,4.367,0,0,1-88.723,0h-18.17ZM6.267-15.525h31.05V0H-13.168V-83.778H6.267Zm92.46-51.232a7.3,7.3,0,0,1-1.811,2.07,4.053,4.053,0,0,1-2.444.69,5.978,5.978,0,0,1-2.846-.834q-1.524-.834-3.45-1.869a28.631,28.631,0,0,0-4.4-1.869,17.6,17.6,0,0,0-5.635-.834q-5.462,0-8.136,2.329a7.923,7.923,0,0,0-2.674,6.3,5.8,5.8,0,0,0,1.61,4.2,13.88,13.88,0,0,0,4.226,2.875,45.3,45.3,0,0,0,5.98,2.214q3.364,1.006,6.871,2.243a61.452,61.452,0,0,1,6.871,2.9,22.914,22.914,0,0,1,5.98,4.255,19.859,19.859,0,0,1,4.226,6.3,22.387,22.387,0,0,1,1.61,8.941A29.135,29.135,0,0,1,102.7-15.985a25.445,25.445,0,0,1-5.836,8.826,27.09,27.09,0,0,1-9.43,5.923A35.28,35.28,0,0,1,74.693.92,40.823,40.823,0,0,1,66.729.115,47.3,47.3,0,0,1,58.88-2.156a45.515,45.515,0,0,1-7.13-3.479,30.3,30.3,0,0,1-5.807-4.485l5.75-9.085a4.68,4.68,0,0,1,1.783-1.667,5.05,5.05,0,0,1,2.472-.633,6.546,6.546,0,0,1,3.479,1.093Q61.18-19.32,63.394-18a32.288,32.288,0,0,0,5.089,2.415,19.08,19.08,0,0,0,6.785,1.093q5.29,0,8.222-2.329t2.933-7.389a6.983,6.983,0,0,0-1.61-4.772,12.438,12.438,0,0,0-4.226-3.048,38.94,38.94,0,0,0-5.951-2.127q-3.335-.92-6.843-2.041a50.06,50.06,0,0,1-6.842-2.76A21.6,21.6,0,0,1,55-43.269a20.18,20.18,0,0,1-4.226-6.67,26.484,26.484,0,0,1-1.61-9.861,23.4,23.4,0,0,1,1.9-9.2,23.748,23.748,0,0,1,5.577-7.993A27.425,27.425,0,0,1,65.665-82.6a33.341,33.341,0,0,1,12.247-2.1,45.927,45.927,0,0,1,7.5.6,39.447,39.447,0,0,1,6.929,1.783,38.05,38.05,0,0,1,6.124,2.818,28.235,28.235,0,0,1,5.089,3.709Z",
    transform: "translate(196.436 232.31)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsIcon);
export default __webpack_public_path__ + "static/media/xls_icon.74e9b4f29efb6584e0747987ae7cebbd.svg";
export { ForwardRef as ReactComponent };